import * as Sentry from '@sentry/browser';
import { useCarrierFeatures } from 'shared/settings/CarrierSettingsAPI';
import { isFlagEnabled } from 'shared/settings/FeatureToggles';
import { FeatureToggle } from 'shared/settings/CarrierSettingsAPI';
import { useEffect } from 'react';

export function useSentryFeatureToggles() {
  const features = useCarrierFeatures();

  useEffect(() => {
    try {
      const flagsIntegration =
        Sentry.getClient()?.getIntegrationByName<Sentry.FeatureFlagsIntegration>(
          'FeatureFlags',
        );
      if (flagsIntegration) {
        if (features) {
          Object.keys(features).forEach((key) => {
            const feature = key as FeatureToggle;
            const isEnabled = isFlagEnabled(features, feature);
            flagsIntegration.addFeatureFlag(feature, isEnabled);
          });
        }
      }
    } catch (error) {
      throw new Error('Failed to update Sentry feature flags', {
        cause: error,
      });
    }
  }, [features]);
}
